import React, { useState } from "react";
import blogPosts from "../../Data/BlogData";

export const BlogComponent = () => {
  const [visiblePosts, setVisiblePosts] = useState(9);

  const loadMore = () => {
    setVisiblePosts(prevVisiblePosts => prevVisiblePosts + 9);
  };

  const loadLess = () => {
    setVisiblePosts(9);
  };

  return (
    <div className="max-w-7xl mx-auto py-10 px-4">
      <div className="w-3/4 mx-auto text-center">
        <h1 className="text-[32px]">Blog</h1>
        <p className="text-[18px] py-4">
          We're doing our best to keep you up-to-date with the latest UI design
          trends, UI freebies, and tips that will help you create awesome user
          experiences faster & more efficiently.
        </p>
      </div>

      <div className="grid grid-cols-1 py-2 md:grid-cols-2 lg:grid-cols-3 gap-[24px]">
        {blogPosts.slice(0, visiblePosts).map((blog) => (
          <a href="/Pages/Blog/Detail" key={blog.id}>
            <img className="rounded-xl" src={blog.imageUrl} alt="" />
            <p className="py-2 text-xl">{blog.title}</p>
          </a>
        ))}
      </div>

      <div className="text-center mt-6">
        {visiblePosts < blogPosts.length ? (
          <button
            onClick={loadMore}
            className="bg-[#1c1c1c] text-white dark:bg-white dark:text-black px-4 py-[11px] rounded-lg"
          >
            Load ({Math.min(9, blogPosts.length - visiblePosts)}) More
          </button>
        ) : (
          <button
            onClick={loadLess}
            className="bg-[#1c1c1c] text-white dark:bg-white dark:text-black px-4 py-[11px] rounded-lg"
          >
            Load Less
          </button>
        )}
      </div>
    </div>
  );
};
